import * as yup from "yup"

export const schemaCommentDraft = yup.object().shape({
  description: yup.string().required("Nhập mô tả.")
})

export const schemaWorkingHighGMV = yup.object().shape({
  submitUrl: yup.string().required("Vui lòng nhập đường dẫn."),
  codeAds: yup.string().optional()
})
